import React from "react";
import Navbar from '../components/Navbar';
import Header from '../components/Header';
import FloatButton from '../components/FloatButton';
import Services from '../components/Services';
import Footer from '../components/Footer';
import OffersSection from "../components/OffersSection";
import VideoGallery from "../components/VideoGalery";
import GalleryComponent from "../components/GalleryComponent";
import ContactSection from "../components/ContactSection";
import { ModernContactForm } from "../components/ContactModal";

const navItems = [
    { link: "#Services", item: "Services" },
    { link: "#Offers", item: "Offers" },
    { link: "#VideoGallery", item: "Videos" },
    { link: "#ImageGallery", item: "Gallery" },
    { link: "#ContactInfo", item: "Contact" },
];

const Home = () => {
    return (
        <>
            <Navbar items={navItems} />
            <Header />
            <main>
                <Services />
                <OffersSection />
                <VideoGallery />
                <GalleryComponent />
                <ContactSection />
            </main>
            <Footer />
            <FloatButton />
            <ModernContactForm />
        </>
    );
}

export default Home;
